<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2359_556)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.89316 12.3068L3.59961 4.30017H8.58455L12.4695 9.24883L16.62 4.32245H19.3654L13.7969 10.9397L20.3996 19.3502H15.4295L11.2229 13.9985L6.73194 19.3353H3.97162L9.89316 12.3068ZM16.154 17.8667L6.65621 5.78366H7.85957L17.3454 17.8667H16.154Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_2359_556">
        <rect
          width="16.8"
          height="16.8"
          fill="white"
          transform="translate(3.59961 3.60022)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
